<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-expand`]" width="1em" height="1em" v-bind="$attrs"><path d="M10.409 6.96973C10.6687 7.22907 11.0898 7.22926 11.3494 6.96973C11.609 6.71014 11.6088 6.28901 11.3494 6.0293L8.68243 3.3623L8.60919 3.2959C8.23019 2.98702 7.67042 3.00913 7.3172 3.3623L4.65021 6.0293C4.39111 6.28887 4.39114 6.71013 4.65021 6.96973C4.90991 7.22943 5.33192 7.22943 5.59161 6.96973L7.99982 4.56055L10.409 6.96973ZM7.3172 12.6367C7.67044 12.99 8.23017 13.0121 8.60919 12.7031L8.68243 12.6367L11.3494 9.96973C11.6088 9.71 11.609 9.28888 11.3494 9.0293C11.0898 8.76982 10.6687 8.76997 10.409 9.0293L7.99982 11.4385L5.59161 9.0293C5.33191 8.76965 4.90989 8.76962 4.65021 9.0293C4.39106 9.28886 4.39113 9.71012 4.65021 9.96973L7.3172 12.6367Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineExpand',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
